/**
 * Gestionnaire de changement de variante pour Wishlist Plus (Swym)
 * Écoute l'événement personnalisé sw:variantchanged et met à jour le bouton wishlist
 */

(function() {
  'use strict';

  class SwymVariantHandler {
    constructor() {
      this.wishlistButton = null;
      this.swatInstance = null;
      this.manualClickHandler = null;
      this.init();
    }

    init() {
      // Attendre que Swym soit chargé
      if (window.SwymCallbacks) {
        window.SwymCallbacks.push((swat) => {
          this.swatInstance = swat;
          this.setupVariantListener();
          this.setupManualClickHandler();
          this.checkInitialWishlistState(); // Vérifier l'état initial
          console.log('✅ SwymVariantHandler initialisé');
        });
      } else if (window._swat) {
        this.swatInstance = window._swat;
        this.setupVariantListener();
        this.setupManualClickHandler();
        this.checkInitialWishlistState(); // Vérifier l'état initial
        console.log('✅ SwymVariantHandler initialisé (Swym déjà chargé)');
      } else {
        // Réessayer après un délai
        setTimeout(() => this.init(), 500);
      }
    }

    setupVariantListener() {
      // Trouver le bouton wishlist
      this.findWishlistButton();

      // Écouter l'événement de changement de variante
      document.addEventListener('sw:variantchanged', (event) => {
        console.log('🔔 Événement sw:variantchanged reçu:', event.detail);
        this.handleVariantChange(event);
      });
    }

    setupManualClickHandler() {
      if (!this.findWishlistButton()) return;

      // Supprimer l'ancien handler si existant
      if (this.manualClickHandler) {
        this.wishlistButton.removeEventListener('click', this.manualClickHandler);
      }

      // Créer un nouveau handler
      this.manualClickHandler = (e) => this.handleWishlistClick(e);
      
      // Attacher le handler en utilisant capture phase pour intercepter avant Swym
      this.wishlistButton.addEventListener('click', this.manualClickHandler, true);
      
      console.log('✅ Click handler manuel attaché');
    }

    checkInitialWishlistState() {
      if (!this.findWishlistButton() || !this.swatInstance) return;

      const currentVariantId = parseInt(this.wishlistButton.getAttribute('data-epi'));
      const productId = parseInt(this.wishlistButton.getAttribute('data-empi'));

      if (!currentVariantId || !productId) {
        console.warn('⚠️ Impossible de vérifier l\'état initial: IDs manquants');
        return;
      }

      console.log('🔍 Vérification état initial pour variante:', currentVariantId);

      // Vérifier si la variante est dans la wishlist
      this.swatInstance.fetch((products) => {
        const isInWishlist = products.some(p => {
          return p.epi === currentVariantId && p.empi === productId;
        });

        if (isInWishlist) {
          this.wishlistButton.classList.add('swym-added', 'swym-heart');
          console.log('✅ Variante déjà dans la wishlist (état initial)');
        } else {
          this.wishlistButton.classList.remove('swym-added', 'swym-heart');
          console.log('ℹ️ Variante non présente dans la wishlist (état initial)');
        }

        // Marquer comme chargé
        this.wishlistButton.classList.add('swym-loaded');
        this.wishlistButton.style.opacity = '1';
      });
    }

    handleWishlistClick(e) {
      if (!this.swatInstance) return;

      // Empêcher le comportement par défaut de Swym
      e.stopPropagation();
      e.preventDefault();

      const variantId = parseInt(this.wishlistButton.getAttribute('data-epi'));
      const productId = parseInt(this.wishlistButton.getAttribute('data-empi'));
      const productUrl = this.wishlistButton.getAttribute('data-du');
      const productTitle = this.wishlistButton.getAttribute('data-product-title');

      console.log('🖱️ Clic wishlist intercepté pour variante:', variantId);

      // Vérifier si déjà dans la wishlist
      this.swatInstance.fetch((products) => {
        const existingProduct = products.find(p => p.epi === variantId && p.empi === productId);

        if (existingProduct) {
          // Retirer de la wishlist
          console.log('➖ Retrait de la wishlist...');
          this.swatInstance.removeFromWishList(existingProduct, () => {
            this.wishlistButton.classList.remove('swym-added', 'swym-heart');
            console.log('✅ Variante retirée de la wishlist');
          }, (error) => {
            console.error('❌ Erreur lors du retrait:', error);
          });
        } else {
          // Ajouter à la wishlist
          console.log('➕ Ajout à la wishlist...');
          
          // Récupérer les données de la variante depuis SwymProductVariants (créé par swym-product-view.liquid)
          const variantData = window.SwymProductVariants && window.SwymProductVariants[variantId];
          
          // Construire l'objet produit pour Swym avec toutes les données nécessaires
          const productData = {
            empi: productId,
            epi: variantId,
            du: productUrl,
            dt: productTitle,
            // Ajouter l'image de la variante si disponible
            iu: variantData ? variantData.iu : undefined,
            // Ajouter le prix si disponible
            pr: variantData ? variantData.pr : undefined,
            // Ajouter la disponibilité
            stk: variantData ? variantData.stk : undefined
          };

          console.log('📦 Données produit à ajouter:', productData);

          this.swatInstance.addToWishList(productData, () => {
            this.wishlistButton.classList.add('swym-added', 'swym-heart');
            console.log('✅ Variante ajoutée à la wishlist');
          }, (error) => {
            console.error('❌ Erreur lors de l\'ajout:', error);
          });
        }
      });
    }

    findWishlistButton() {
      this.wishlistButton = document.querySelector('.swym-button.swym-add-to-wishlist-view-product');
      
      if (!this.wishlistButton) {
        console.warn('⚠️ Bouton wishlist non trouvé');
        return false;
      }
      
      console.log('✅ Bouton wishlist trouvé:', this.wishlistButton);
      return true;
    }

    handleVariantChange(event) {
      if (!this.findWishlistButton()) {
        console.error('❌ Impossible de trouver le bouton wishlist');
        return;
      }

      const { currentVariantId, productId } = event.detail.d;
      
      if (!currentVariantId) {
        console.error('❌ ID de variante manquant dans l\'événement');
        return;
      }

      console.log(`🔄 Mise à jour du bouton wishlist: variante ${currentVariantId}`);

      // Mettre à jour les attributs du bouton
      this.updateButtonAttributes(currentVariantId, productId);

      // Réinitialiser l'état visuel du bouton
      this.refreshButtonState();
      
      // Réattacher le click handler (au cas où le bouton aurait changé)
      this.setupManualClickHandler();
    }

    updateButtonAttributes(variantId, productId) {
      if (!this.wishlistButton) return;

      // Mettre à jour data-epi (variant ID) - CRUCIAL
      this.wishlistButton.setAttribute('data-epi', variantId);
      
      // Mettre à jour data-empi si fourni
      if (productId) {
        this.wishlistButton.setAttribute('data-empi', productId);
      }

      // Mettre à jour data-variant-id si l'attribut existe
      if (this.wishlistButton.hasAttribute('data-variant-id')) {
        this.wishlistButton.setAttribute('data-variant-id', variantId);
      }

      console.log('✅ Attributs du bouton mis à jour:', {
        'data-epi': variantId,
        'data-empi': productId
      });
    }

    refreshButtonState() {
      if (!this.wishlistButton || !this.swatInstance) {
        console.error('❌ Impossible de rafraîchir: bouton ou instance Swym manquant');
        return;
      }

      try {
        // Récupérer l'ID de variante actuel
        const currentVariantId = parseInt(this.wishlistButton.getAttribute('data-epi'));
        const productId = parseInt(this.wishlistButton.getAttribute('data-empi'));
        
        if (!currentVariantId) {
          console.error('❌ ID de variante invalide');
          return;
        }

        // Vérifier si la variante est déjà dans la wishlist
        this.swatInstance.fetch((products) => {
          // Chercher le produit et la variante spécifique
          const isInWishlist = products.some(p => {
            return p.epi === currentVariantId && p.empi === productId;
          });
          
          // Mettre à jour visuellement le bouton
          if (isInWishlist) {
            this.wishlistButton.classList.add('swym-added');
            this.wishlistButton.classList.add('swym-heart');
            console.log('✅ Variante déjà dans la wishlist');
          } else {
            this.wishlistButton.classList.remove('swym-added');
            this.wishlistButton.classList.remove('swym-heart');
            console.log('ℹ️ Variante non présente dans la wishlist');
          }

          // S'assurer que le bouton est visible et chargé
          this.wishlistButton.classList.add('swym-loaded');
          this.wishlistButton.style.opacity = '1';
        });

        console.log('✅ État du bouton rafraîchi pour variante:', currentVariantId);
      } catch (error) {
        console.error('❌ Erreur lors du rafraîchissement du bouton:', error);
      }
    }
  }

  // Initialisation au chargement du DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new SwymVariantHandler();
    });
  } else {
    new SwymVariantHandler();
  }
})();

